import React from 'react'

import { type StepComponentProps } from '../types'
import { AllowedOffThatchMedicalPlans } from './AllowedOffThatchMedicalPlans'
import { OffThatchMedicalPlanDetails } from './OffThatchMedicalPlanDetails'

type OffThatchMedicalRouterProps = StepComponentProps & {
  setViewingOffThatch: (viewingOffThatch: boolean) => void
  existingPlan: boolean
}

export function OffThatchMedicalRouter (props: OffThatchMedicalRouterProps) {
  const { setViewingOffThatch } = props

  const [showPlanDetails, setShowPlanDetails] = React.useState(props.existingPlan)

  if (showPlanDetails) {
    return <OffThatchMedicalPlanDetails {...props} setShowPlanDetails={setShowPlanDetails} />
  }

  return <AllowedOffThatchMedicalPlans {...props} setViewingOffThatch={setViewingOffThatch} onContinue={() => setShowPlanDetails(true)} />
}
